import { useEffect, useState } from 'react'
import AccountsTable from '../../components/admin/accounts/AccountsTable'
import Header from '../../components/admin/accounts/Header'
import api from '../../utils/api'
import styles from './Accounts.module.css'

const Accounts = () => {
  const [data, setData] = useState([])
  const [editId, setEditId] = useState(null)
  const [savingId, setSavingId] = useState(null)

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const { data } = await api.get('accounts')
        setData(data.sort((a, b) => a.id - b.id))
      } catch (error) {
        console.error('Error fetching accounts:', error)
      }
    }

    fetchAccounts()
  }, [])

  const handleEdit = (id) => {
    setEditId(id)
  }

  const handleSave = async (id, newData) => {
    setSavingId(id)
    try {
      await api.put(`accounts/${id}`, newData)
      setData((prev) => prev.map((row) => (row.id === id ? { ...row, ...newData } : row)))
    } catch (error) {
      console.error('Error updating account:', error)
    }
    setSavingId(null)
    setEditId(null)
  }

  const handleCancel = () => {
    if (savingId) return // Prevent cancel during save
    setEditId(null)
  }

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.tableContainer}>
        <AccountsTable editId={editId} savingId={savingId} data={data} handleEdit={handleEdit} handleSave={handleSave} handleCancel={handleCancel} />
      </div>
    </div>
  )
}

export default Accounts
